import * as IoC from 'typescript-ioc';

import * as THEMES_API from '../../constants/api/themes-api';
import { IApiClient, RequestContentType } from '../../infrastructure/api-client';
import { ICreateThemeDTO, IAssetUrlDTO, IThemeDTO, IThemesDAO, IUpdateThemeDTO } from '../themes.dao';
import { JobDtoType } from '../../domain/jobs';


class ThemesDAO extends IThemesDAO {

    constructor(@IoC.Inject private readonly apiClient: IApiClient) {
        super();
    }

    public async getThemeList(params: { accountId: number }): Promise<IThemeDTO[]> {
        const response = await this.apiClient.get<IThemeDTO[]>(THEMES_API.THEMES_LIST_URL, { ...params });
        return response.parsedResponse;
    }

    public async getThemeListByName(name = ''): Promise<IThemeDTO[]> {
        const response = await this.apiClient.get<IThemeDTO[]>(THEMES_API.THEMES_LIST_SEARCH_URL, { name: name });
        return response.parsedResponse;
    }

    public async createTheme(params: ICreateThemeDTO): Promise<IThemeDTO> {
        const assetUrlParams = await this.getS3AssetUrl();
        await this.uploadThemeToS3(assetUrlParams.assetUrl, params.themeArchive);
        const response = await this.apiClient.post<IThemeDTO>(THEMES_API.NEW_THEME_URL, {
            name: params.name,
            location: assetUrlParams.location,
            allAccounts: params.allAccounts,
            accountIds: params.accountIds,
        });
        return response.parsedResponse;
    }

    public async updateTheme(params: IUpdateThemeDTO): Promise<IThemeDTO> {
        if (params.themeArchive) {
            const assetUrlParams = await this.getS3AssetUrl();
            await this.uploadThemeToS3(assetUrlParams.assetUrl, params.themeArchive);
            params.location = assetUrlParams.location;
        }
        const response = await this.apiClient.put<IThemeDTO>(THEMES_API.UPDATE_THEME_URL, params);
        return response.parsedResponse;
    }

    public async getS3AssetUrl(): Promise<IAssetUrlDTO> {
        const response = await this.apiClient.get<IAssetUrlDTO>(THEMES_API.GET_THEME_S3_URL);
        return response.parsedResponse;
    }

    public async uploadThemeToS3(url: string, themeArchive: File) {
        const response = await this.apiClient.put<JobDtoType>(url, themeArchive, {
            ContentType: RequestContentType.zip
        });
        return response.parsedResponse;
    }
}

export { ThemesDAO };
